import { Component, Prop, Vue } from 'vue-property-decorator';
import { IZipcodeIntakeFormConfig } from '../models';
import {
    isZipcodeLessThanFiveCharacters,
    isZipcodeIncludeAlphaChar,
    isZipcodeIncludeSpecialChar,
} from '@andromeda/util-environment';

@Component({
})

export default class ZipcodeIntakeForm extends Vue {
    @Prop({ required: true }) zipcodeIntakeFormConfig!: IZipcodeIntakeFormConfig;

    isSubmitButtonDisabled = false;
    zipcodeInputFieldValue = '';
    isErrorTextVisible = false;

    get zipcodeIntakeFormClasses(): string {
        const stylingClasses:string[] = [];

        stylingClasses.push('zipcode-intake-form')

        if(this.isSubmitButtonDisabled) {
            stylingClasses.push('btn-disabled');
        }

        if(this.isErrorShowing) {
            stylingClasses.push('zipcode-error-flag');
        }
        
        return stylingClasses.join(' ');
    }

    get isErrorShowing(): boolean {
        return this.zipcodeIntakeFormConfig.isErrorTextVisible || this.isErrorTextVisible ? true : false;
    }

    get isSubmitDisabled(): boolean {
        return this.isSubmitButtonDisabled;
    }

    get zipcodeSectionHeaderText(): string {
        return this.zipcodeIntakeFormConfig.headerText ? this.zipcodeIntakeFormConfig.headerText : 'Missing Required Prop: headerText';
    }

    get zipcodeSectionBtnText(): string {
        return this.zipcodeIntakeFormConfig.buttonText ? this.zipcodeIntakeFormConfig.buttonText : 'Missing Required Prop: buttonText';
    }

    get zipcodeSectionErrorText(): string {
        return this.zipcodeIntakeFormConfig.errorText ? this.zipcodeIntakeFormConfig.errorText : 'Missing Required Prop: errorText';
    }

    get inputPlaceholderText(): string {
        return this.zipcodeIntakeFormConfig.inputPlaceholderText ? this.zipcodeIntakeFormConfig.inputPlaceholderText : '';
    }

    isCalveraAdTypeSingleProductMultiRetailer(): boolean {
        return false; //this.zipcodeIntakeFormConfig.calveraAdType === 'singleProductMultiRetailer';
    }
    
    /*
        ignoreCharacterPrecheck was intented for input type=["number"]...
        However, input type=["number"] is not yet fully supported in all browsers
        more info here: 
        https://caniuse.com/input-number
        and here:
        https://stackoverflow.com/questions/18510845/maxlength-ignored-for-input-type-number-in-chrome
    */
    /*
    ignoreCharacterPrecheck(event:KeyboardEvent) {
        const ignoredKeys = ['E', 'e', '+', '-'];
         // Keys above are ignored, we don't need postive, negative or exponentials so ignore keydown event
        if(ignoredKeys.includes(event.key)){
            event.preventDefault();
            return;
        }
        // Otherwise proceed as normal to update the input fields value but also update the current "state"
        const inputField = event.target as HTMLInputElement;
        this.zipcodeInputFieldValue = inputField.value;
    }
    */

    submitZipcodeClick(): void {
        if(this.isSubmitButtonDisabled || !this.zipcodeInputFieldValue){
            return;
        }
        this.$emit('submitZipcodeClick', this.zipcodeInputFieldValue);
    }

    zipcodePrecheck(event:Event) {
        const inputField = event.target as HTMLInputElement;
        this.zipcodeInputFieldValue = inputField.value;

        this.$emit('clearZipcodeErrorFlag');
        this.isErrorTextVisible = false;
        this.isSubmitButtonDisabled = false;

        if(isZipcodeLessThanFiveCharacters(this.zipcodeInputFieldValue)) {
            //console.log('Zipcode is currently less than 5 characters...');
            //console.log('We\'ve cleared the error but doing another check against non-numeric and special characters');
            this.isSubmitButtonDisabled = true;
            if(isZipcodeIncludeAlphaChar(this.zipcodeInputFieldValue) || isZipcodeIncludeSpecialChar(this.zipcodeInputFieldValue)){
                this.isErrorTextVisible = true;
            }
            return;
        }

        if(isZipcodeIncludeAlphaChar(this.zipcodeInputFieldValue) || isZipcodeIncludeSpecialChar(this.zipcodeInputFieldValue)){
            this.isSubmitButtonDisabled = true;
            this.isErrorTextVisible = true;
            return;
        }

    }
}
